import { Component, OnInit, AfterViewInit, HostListener } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { BreadcrumbsService } from '@bci-web-core/core';
import { Observable, Subject, Subscription, timer } from 'rxjs';

export let browserRefresh = false;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
  private subscription: Subscription;

  constructor(
    private breadcrumbsService: BreadcrumbsService
    , private router: Router) {

  }

  ngOnInit() {
    const t = this;
    setTimeout(function () {
      t.breadcrumbsService.setTitle('home', 'RBEI , BOSCHJAIPUR , JAIPUR');
    }, 200);
  }
  ngAfterViewInit() {
  }
}
